import React from 'react';

import { Svg, SvgPath, SvgProps } from '@rbilabs/universal-components';

import Styles from 'styles/constants';
import { primitive } from 'styles/constants/primitives';

const MARKER_DIMENSIONS = {
  width: 48,
  height: 60,
  viewBox: '0 0 48 60',
} as const;

const DRIVER_PATHS = {
  background:
    'M16.789.327C8.333.327 1.494 7.166 1.494 15.62c0 11.471 15.295 28.405 15.295 28.405S32.084 27.092 32.084 15.62c0-8.455-6.84-15.294-15.295-15.294Z',
  content:
    'M22.833 10.833c0-.916-.75-1.666-1.666-1.666h-2.5v1.666h2.5v2.209l-2.9 3.625h-2.934V12.5H12a3.332 3.332 0 0 0-3.333 3.333v2.5h1.666c0 1.384 1.117 2.5 2.5 2.5 1.384 0 2.5-1.116 2.5-2.5h3.734l3.766-4.708v-2.792Zm-10 8.334a.836.836 0 0 1-.833-.834h1.667a.836.836 0 0 1-.834.834Zm2.5-9.167h-4.166v1.667h4.166V10Zm5 8.333c0-1.383 1.117-2.5 2.5-2.5 1.384 0 2.5 1.117 2.5 2.5 0 1.384-1.116 2.5-2.5 2.5a2.497 2.497 0 0 1-2.5-2.5Zm1.667 0c0 .459.375.834.833.834a.836.836 0 0 0 .834-.834.836.836 0 0 0-.834-.833.836.836 0 0 0-.833.833Z',
} as const;

const COLORS = {
  background: primitive.bk.$fieryRed,
  content: primitive.bk.$white,
} as const;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SHADOW_STYLES: any = {
  shadowColor: Styles.shadowColor,
  shadowOffset: {
    width: 1.2,
    height: 1.2,
  },
  shadowRadius: 1.5,
  shadowOpacity: 0.8,
  elevation: 10, // for android
};

const defaultAccessibilityLabel = 'Driver marker';

interface DriverMarkerProps extends SvgProps {
  accessibilityLabel?: string;
  testID?: string;
}

export const DriverMarker: React.FC<DriverMarkerProps> = ({
  accessibilityLabel,
  testID,
  ...svgProps
}) => (
  <Svg
    width={MARKER_DIMENSIONS.width}
    height={MARKER_DIMENSIONS.height}
    viewBox={MARKER_DIMENSIONS.viewBox}
    fill="none"
    style={SHADOW_STYLES}
    accessible={true}
    accessibilityLabel={accessibilityLabel || defaultAccessibilityLabel}
    testID={testID}
    {...svgProps}
  >
    <SvgPath d={DRIVER_PATHS.background} fill={COLORS.background} />
    <SvgPath d={DRIVER_PATHS.content} fill={COLORS.content} fillRule="evenodd" clipRule="evenodd" />
  </Svg>
);

export const driverMarkerSvg = `<svg width="${MARKER_DIMENSIONS.width}" height="${MARKER_DIMENSIONS.height}" viewBox="${MARKER_DIMENSIONS.viewBox}" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="${DRIVER_PATHS.background}" fill="${COLORS.background}" />
  <path d="${DRIVER_PATHS.content}" fill="${COLORS.content}" fillRule="evenodd" clipRule="evenodd" />
</svg>`;
